export default "__VITE_ASSET__CUL05_du__"